import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { ReadingIntentionsMenuComponent } from './reading-intentions-menu.component';

@NgModule({
  imports: [CommonModule, BsDropdownModule],
  declarations: [ReadingIntentionsMenuComponent],
  exports: [ReadingIntentionsMenuComponent],
})
export class ReadingIntentionsMenuModule {}
